<script>
</script>

<div>
  <h1>
    <span style="font-weight: 100;">Lern</span>
    <span style="font-weight: 600;">Live</span>
  </h1>
</div>

<style>
  div {
    height: 64px;
    display: flex;
    align-items: center;
  }

  h1 {
    color: #fff;
    margin-bottom: 0;
    display: flex;
  }
</style>
